import type { EarlyWarningItem, PriceRiseItem, PriceRisesResponse } from "@/lib/api";

export function riseRows(items: PriceRiseItem[]): PriceRiseItem[] {
  return [...items].sort((a, b) => b.severity - a.severity || (b.streakPct ?? b.pct4w ?? 0) - (a.streakPct ?? a.pct4w ?? 0) || a.displayName.localeCompare(b.displayName, "tr"));
}

export function riseState(data: Pick<PriceRisesResponse, "streaks" | "rising">): "empty" | "results" {
  return data.streaks.length || data.rising.length ? "results" : "empty";
}

/** Backend streakWeeks counts the weekly price points in the rising run. */
export function streakStartIndex(seriesLength: number, streakWeeks: number): number | null {
  if (streakWeeks < 4 || seriesLength < 2) return null;
  return Math.max(0, seriesLength - streakWeeks);
}

export function longestStreak(items: PriceRiseItem[]): PriceRiseItem | null {
  return [...items].sort((a, b) => b.streakWeeks - a.streakWeeks || b.severity - a.severity)[0] ?? null;
}

export function imageFallback(name: string): string {
  return Array.from(name.trim())[0]?.toLocaleUpperCase("tr-TR") ?? "?";
}

export function warningRows(items: EarlyWarningItem[]): EarlyWarningItem[] {
  return [...items].sort((a, b) => b.severity - a.severity || b.pctChange - a.pctChange || a.displayName.localeCompare(b.displayName, "tr"));
}

export function warningTier(tier: EarlyWarningItem["tier"]): string {
  return tier === "güçlü" ? "Güçlü" : "İzle";
}

export function warningState(items: EarlyWarningItem[]): "empty" | "results" {
  return items.length ? "results" : "empty";
}

export function sparklinePoints(buckets: EarlyWarningItem["buckets"], width = 96, height = 32): string {
  const min = Math.min(...buckets);
  const max = Math.max(...buckets);
  const range = max - min || 1;
  return buckets.map((value, index) => `${(index * width / 3).toFixed(1)},${(height - 3 - (value - min) / range * (height - 6)).toFixed(1)}`).join(" ");
}
